/* T&S — Elevated polish JS
   Magnetic CTA · Reveal observer · Marquee duplicate
   Loaded with `defer` from theme.liquid
*/
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ───────────── 1. Reveal-on-scroll (IntersectionObserver upgrade) ───────────── */
  function initReveal() {
    var nodes = document.querySelectorAll('.kala-reveal, .kala-reveal--stagger');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ───────────── 2. Magnetic CTA — subtle pull on hover ───────────── */
  function initMagnetic() {
    if (prefersReduced) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var els = document.querySelectorAll('[data-magnetic]');
    if (!els.length) return;

    els.forEach(function (el) {
      var strength = parseFloat(el.dataset.magnetic) || 0.25;
      var rect;

      function onEnter() { rect = el.getBoundingClientRect(); }
      function onMove(e) {
        if (!rect) rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
      }
      function onLeave() {
        el.style.transform = '';
        rect = null;
      }
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', onLeave);
    });
  }

  /* ───────────── 3. Marquee duplicator — ensures seamless loop ───────────── */
  function initMarquee() {
    var marquees = document.querySelectorAll('.kala-marquee');
    marquees.forEach(function (m) {
      if (m.dataset.kalaMarqueeReady) return;
      m.dataset.kalaMarqueeReady = '1';
      var track = m.querySelector('.kala-marquee__track');
      if (!track) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      m.appendChild(clone);
    });
  }

  /* ───────────── 4. Subtle parallax on hero images (data-parallax) ───────────── */
  function initParallax() {
    if (prefersReduced) return;
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var raf = null;
    var current = [];

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        current.forEach(function (entry) {
          var rect = entry.el.getBoundingClientRect();
          var vh = window.innerHeight;
          var pct = (rect.top + rect.height / 2 - vh / 2) / vh;
          entry.el.style.setProperty('--py', (pct * entry.amount).toFixed(2) + 'px');
        });
        raf = null;
      });
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        var amount = parseFloat(el.dataset.parallax) || -40;
        if (e.isIntersecting) {
          if (!current.find(function (x) { return x.el === el; })) {
            current.push({ el: el, amount: amount });
          }
        } else {
          current = current.filter(function (x) { return x.el !== el; });
        }
      });
    }, { threshold: [0, 0.1, 0.5, 1] });
    els.forEach(function (el) { io.observe(el); });
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ───────────── Boot ───────────── */
  function boot() {
    initReveal();
    initMagnetic();
    initMarquee();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
